import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IViewModel } from '../interfaces/view-model.interface';
import { Logging } from '../logging';
import { PickerItem } from '../models/picker-item.model';
import { BehaviorSubject, EMPTY } from 'rxjs';

@Injectable()
export class MaxPickerService {
    public isSearching = new BehaviorSubject(false);
    
    constructor(private http: HttpClient) { }

    search(query: string, max: number = 100, scope: string = 'usersAndGroups'): Promise<PickerItem[]> {
        if ((!query) || (query.length == 0)) { return EMPTY.toPromise(); }

        this.isSearching.next(true);

        var url = `${environment.apiUrl}/frameworkapi/maxpicker/search?searchstring=${query}&maxcount=${max}&scope=${scope}`;

        return this.http
            .get<PickerItem[]>(url)
            .toPromise()
            .then(response => {
                var data: PickerItem[] = [];

                response.forEach(x => {
                    data.push(new PickerItem(x));
                });
                this.isSearching.next(false);

                
                // Uncomment this to work around the picker server service not working on dev
                // this.addFakeUsers(data);

                return data;
            })
            .catch(this.handleError);
    }

    private addFakeUsers(data: PickerItem[]) {
        var pi = new PickerItem({
            key: 'O001154',
            displayName: 'P J. Harvey',
            secondaryDisplayName: 'pharvey@omb.eop.gov',
            isUser: true,
            isActive: true,
            fullDisplay: `P J. Harvey (OMB,Ctr) - pharvey@omb.eop.gov`,
            phone: '240-357-6564',
            phoneExt: '',
            agencyShortName: 'OMB'
        });

        data.push(pi);
        var pi2 = new PickerItem({
            key: 'O001154',
            displayName: 'John J. Jarvey',
            secondaryDisplayName: 'jjarvey@omb.eop.gov',
            isUser: true,
            isActive: true,
            fullDisplay: `J J. Jarvey (OMB,Ctr) - jjarvey@omb.eop.gov`,
            phone: '240-357-6564',
            phoneExt: '',
            agencyShortName: 'OMB'
        });
        data.push(pi2);

        var pi3 = new PickerItem({
            key: 'O001154',
            displayName: 'Kal J. Karvey',
            secondaryDisplayName: 'kkarvey@omb.eop.gov',
            isUser: true,
            isActive: true,
            fullDisplay: `K J. Karvey (OMB,Ctr) - kkarvey@omb.eop.gov`,
            phone: '240-357-6564',
            phoneExt: '',
            agencyShortName: 'OMB'
        });
        data.push(pi3);
    }

    handleError(error: Response | any): Promise<any> {
        Logging.log(error);
        return Promise.reject(error.message || error);
    }
}
